/* istanbul ignore file */
import { useDocumentTitle } from './useDocumentTitle';

export default function DocumentTitleEffectWrapper() {
  useDocumentTitle();
  return null;
}
